import { Button, FormControl, FormLabel, IconButton, MenuItem, Paper, Select, Slide, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import { format, isAfter, subMonths, isEqual } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom';
import TipoSituacaoServidorApi from '../../api/TipoSituacaoServidorApi';
import { withAplicacao } from '../../contexts/AplicacaoContext';
import { withUsuario } from '../../contexts/UsuarioContext';
import { withSnackbar } from '../../contexts/SnackbarContext.jsx';
import FilterBeneficiario from '../share/FilterBeneficiario';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import DividasEmAbertoApi from '../../api/DividasEmAbertoApi';
import FullScreenDividasEmAbertoPorPeriodoPrint from './FullScreenDividasEmAbertoPorPeriodoPrint';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'block',
    height: theme.spacing(20),
  },
  divCampos: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    marginTop: theme.spacing(-1),
  },
  verticalMargin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  marginLeft: {
    marginLeft: theme.spacing(1),
  },
  mesRef: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: theme.spacing(15),
  },
  marginLeftButton: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  invisible: {
    display: 'none',
  },
});


class DividasEmAbertoPorPeriodo extends React.Component {
  tiposDeSituacaoApi = new TipoSituacaoServidorApi();
  dividasEmAbertoApi = new DividasEmAbertoApi();

  state = {
    datasDeReferencia: [],
    carteiraSelected: '',
    nomeBeneficiarioSelected: '',
    mesAnoFrom: format(subMonths(new Date(), 12), 'MM/YYYY'),
    mesAnoTo: format(new Date(), 'MM/YYYY'),
    fetching: false,
    fullScreenPrintOpen: false,
    dividasEmAberto: [],
    beneficiarios: [],
    labelPDF: 'VISUALIZAR PDF',
  }

  getListaDatasReferencia () {
    let dataInicial = new Date(2013, 12, 1);
    let dataAtual = new Date();
    let resultado = [];
    while (isAfter(dataAtual, dataInicial)) {
      let registro = format(new Date(dataAtual), 'MM/YYYY');
      resultado.push(registro);
      dataAtual = subMonths(dataAtual, 1);
    }
    this.setState({datasDeReferencia: resultado});
  }

  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarBeneficiarios();
    this.getListaDatasReferencia();
    this.setState({fetching: false});
  }

  consultarBeneficiarios = async () => {
    const beneficiarios = await this.props.getBeneficiarios();
    this.setState({beneficiarios: beneficiarios});
  }

  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({carteiraSelected: carteira,
      nomeBeneficiarioSelected: nome,
      gerarExcelDisabled: nome !== ''});
  }

  handleChangeSelect = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCloseFullScreenPrint = () => {
    this.setState({ fullScreenPrintOpen: false });
  }

  handleClickLimpar = () => {
    this.setState({carteiraSelected: '', nomeBeneficiarioSelected: '',
    mesAnoFrom: format(subMonths(new Date(), 12), 'MM/YYYY'),
    mesAnoTo: format(new Date(), 'MM/YYYY'),});
  }

  datasValidas = () => {
    let anoFrom = Number(this.state.mesAnoFrom.substring(3, 7));
    let mesFrom = Number(this.state.mesAnoFrom.substring(0, 2));
    let dataFrom = new Date(anoFrom, mesFrom, 1);

    let anoTo = Number(this.state.mesAnoTo.substring(3, 7));
    let mesTo = Number(this.state.mesAnoTo.substring(0, 2));
    let dataTo = new Date(anoTo, mesTo, 1);

    return isAfter(dataTo, dataFrom) || isEqual(dataTo, dataFrom);
  }

  handleClickPrint = () => {
    if (this.datasValidas()){
      this.setState({ fullScreenPrintOpen: true });
    } else {
      this.props.showSnackbar('A data final deve maior que a data inicial. ', 'error', 3000, '', null, 'top', 'right');
    }
  }

  render () {
    const { classes } = this.props;
    const { mesAnoFrom, mesAnoTo, datasDeReferencia, fetching } = this.state;

    return (
      <React.Fragment>
        <Link to='/relatorio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Relatório de Dívidas em Aberto - Consolidado por Beneficiário e Período</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.root} elevation={1}>
          <div className={classes.divCampos}>
            <FormControl component='fieldset' className={classes.mesRef}>
              <FormLabel component='legend'>De:</FormLabel>
              <Select
                value={mesAnoFrom}
                onChange={this.handleChangeSelect}
                inputProps={{
                  name: 'mesAnoFrom',
                }}
              >
                {datasDeReferencia.map(anoRef => {
                  return (<MenuItem key={anoRef} value={anoRef}>{anoRef}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl component='fieldset' className={classes.mesRef}>
              <FormLabel component='legend'>Até:</FormLabel>
              <Select
                value={mesAnoTo}
                onChange={this.handleChangeSelect}
                inputProps={{
                  name: 'mesAnoTo',
                }}
              >
                {datasDeReferencia.map(anoRef => {
                  return (<MenuItem key={anoRef} value={anoRef}>{anoRef}</MenuItem>);
                })}
              </Select>
            </FormControl>
            {this.state.beneficiarios.length !== 0 &&
            <FormControl component='fieldset' className={classes.marginLeft}>
              <FilterBeneficiario
                beneficiarios={this.state.beneficiarios}
                handleSelectBeneficiario={this.handleSelectBeneficiario}
                handleClickLimpar={this.handleClickLimpar} 
                maxSuggestions={3} />
            </FormControl>
            }
            <Button
              disabled={this.state.carteiraSelected === ''}
              size='small'
              variant='contained'
              color='primary'
              title='Visualizar'
              type='submit'
              onClick={this.handleClickPrint}
              className={classes.marginLeftButton}>
              <PictureAsPdf className={classes.marginRight} />
              {this.state.labelPDF}
            </Button>
          </div>
        </Paper>
        {this.state.fullScreenPrintOpen &&
        <FullScreenDividasEmAbertoPorPeriodoPrint
          open={this.state.fullScreenPrintOpen}
          handleClose={this.handleCloseFullScreenPrint}
          mesAnoFrom={this.state.mesAnoFrom}
          mesAnoTo={this.state.mesAnoTo}
          codServidor={Number(this.state.carteiraSelected.substring(0, 5))}
          nomeServidor={this.state.nomeBeneficiarioSelected}
        />}
      </React.Fragment>
    );
  }
}

export default withSnackbar(withUsuario(withAplicacao(withStyles(styles)(DividasEmAbertoPorPeriodo))));
